import {createContext, useContext} from 'react';

export type OpenInNewTab = typeof window.open;
const context = createContext<OpenInNewTab>(null);

export const OpenInNewTabProvider = context.Provider;
export const OpenInNewTabConsumer = context.Consumer;
export const useOpenInNewTab = () => useContext(context);
